import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { MechanicInOutSummaryRequestModel } from '../../business-entities/mechanic-clocking-time-request-model';
import { AppointmentPlanningService } from '../../business-services/appointment-planning.service';
import { MechanicTimeStampService } from '../../business-services/mechanic-time-stamp.service';

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const weekEnds = [0, 6];
const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
@Component({
  selector: 'app-af-mechanic-scheduler-list',
  templateUrl: './af-mechanic-scheduler-list.component.html',
  styleUrls: ['./af-mechanic-scheduler-list.component.css']
})
export class AfMechanicSchedulerListComponent implements OnInit {

  @Input() selectedDate: Date;
  isShowAll: boolean = false;
  lang: string = 'en-US';
  @Input() schedularHeader: any;
  @Output() onDayChange = new EventEmitter<Date>();
  @Output() onMonthChange = new EventEmitter<Date>();
  @Input() isView: boolean;
  @Input() isScheduleSummary: boolean;
  @Input() mechanicData: any;
  @Input() dealerName = '';
  @Input() isUsedForUser = false;
  @Output() viewDetails = new EventEmitter<any>();

  summaryList: any;
  timeCodeDetails: any;
  closeResult = '';
  availbleHour: string;
  availbleDateTime: any;
  schedularHeaderInfo: any;
  PlanningMonthBookedMinPerc = 30;
  PlanningMonthBookedMaxPerc = 90
  monthsInfo: any;
  currentDay: any;
  selectedDay: any;
  hour: any = 0;
  monthDays: any;

  constructor(
    private spinner: NgxSpinnerService,
    private appointmentPlanningService: AppointmentPlanningService,
    private datePipe: DatePipe,
    private service: MechanicTimeStampService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.schedularHeaderDataMapper(new Date(this.selectedDate), this.schedularHeader, new Date(this.selectedDate));
    this.monthDays = this.onGetCurrentMonthDates(new Date(this.selectedDate));
  }

  ngOnChanges(_simplechanges): void {
    this.getPlanningCommonMonthInfo(this.schedularHeader, new Date(this.selectedDate), new Date(this.selectedDate));
    this.reloadHeaderData();
    this.monthDays = this.onGetCurrentMonthDates(new Date(this.selectedDate));
  }
  ngAfterViewInit(): void {
    const element = document.getElementById('scrollToMe');
    if (element) {
      element.scrollIntoView({ block: 'nearest', inline: 'center' });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }

  private getPlanningCommonMonthInfo(monthsData: any, cDate: any, sDate: any) {
    let result = monthsData;
    this.monthsInfo = result;
    this.schedularHeaderDataMapper(new Date(cDate), result, new Date(sDate));
  }



  private schedularHeaderDataMapper(cDate: Date, monthsInfo: any, sDate: Date) {
    if (monthsInfo) {
      const currentDate = new Date(cDate);
      const superObject = Object();
      let x = monthsInfo.find(x => (new Date(x.monthOfDate).toLocaleDateString()) === (new Date(cDate).toLocaleDateString()));
      this.availbleHour = (x?.availableHours - x?.plannedHours).toString();
      this.availbleDateTime = new Date();
      if ((x?.availableHours - x?.plannedHours) > 0) {
        const [h, m] = this.availbleHour.split('.');
        this.availbleDateTime.setHours(h);
        this.availbleDateTime.setMinutes(m);
      }
      else {
        this.availbleDateTime.setHours(0);
        this.availbleDateTime.setMinutes(0);
      }
      superObject.currentMonth = `${monthNames[currentDate.getMonth()]}`;
      superObject.currentYear = `${currentDate.getFullYear()}`;

      this.currentDay = `${weekDays[currentDate.getDay()]}, ${monthNames[currentDate.getMonth()]} ${currentDate.getDate()}`;
      const supperArry = [];
      const monthAllDates = this.onGetCurrentMonthDates(cDate);
      const mechanicTotalMonthsPlan = monthsInfo;

      for (const monthDate of monthAllDates) {
        const single = Object();
        single.rentalCars = [];
        let mechanicDayWisePlanned = mechanicTotalMonthsPlan.find(x => (new Date(x.monthOfDate).toLocaleDateString()) === (new Date(monthDate).toLocaleDateString()));

        // calculate is week ends
        single.isHoliday = false;
        if (weekEnds.indexOf(new Date(monthDate).getDay()) != -1) {
          single.isHoliday = true;
        }
        single.dayName = dayNames[new Date(monthDate).getDay()];
        single.actualDate = monthDate;
        single.cdate = new Date(monthDate).getDate();

        if (mechanicDayWisePlanned) {
          single.plannedHours = mechanicDayWisePlanned.plannedHours;
          single.availableHours = mechanicDayWisePlanned.availableHours;



        }

        // set custom class to
        single.isCurrent = false;
        let selectedDate = this.datePipe.transform(new Date(sDate), 'yyyy/MM/dd');
        let monthsDate = this.datePipe.transform(new Date(monthDate), 'yyyy/MM/dd');

        if ((new Date(monthsDate).toLocaleDateString() === new Date(selectedDate).toLocaleDateString())) {
          single.classToSet = 'state-3'
          single.isCurrent = true;
        }

        supperArry.push(single);
      }

      superObject.infos = supperArry;
      this.schedularHeaderInfo = superObject;

    }
  }

  /**
    * Purpose of the method to create whole month dates based on current date
    * @param cDate
    */
  private onGetCurrentMonthDates(cDate: Date): any[] {
    const currentD = new Date(cDate);
    const month = currentD.getMonth();
    currentD.setDate(1);
    const alldays = [];
    while (currentD.getMonth() === month) {
      const calyear = currentD.getFullYear();
      const calmonth = (currentD.getMonth() + 1).toString().padStart(2, '0');
      const caldate = currentD.getDate().toString().padStart(2, '0');
      const d = `${calyear}-${calmonth}-${caldate}`;
      alldays.push(d);
      currentD.setDate(currentD.getDate() + 1);
    }

    return alldays;
  }


  /**
  * Planner Previous button click
  */
  onSchedulerPreviousClick() {
    this.spinner.show();
    const element = document.getElementsByClassName('monthScrollDiv');
    if (element.length > 0) {
      element.item(0).scrollIntoView({ block: 'nearest' });
    }
    let currentDate = new Date(this.selectedDate);

    currentDate.setMonth(currentDate.getMonth() - 1);
    this.onMonthChange.emit(new Date(currentDate));
    this.selectedDate = new Date(currentDate);
    // update current date
    this.reloadHeaderData();
  }

  /**
 *Planner next button click
 */
  onSchedulerNextClick() {
    this.spinner.show();
    const element = document.getElementsByClassName('monthScrollDiv');
    if (element.length > 0) {
      element.item(0).scrollIntoView({ block: 'nearest' });
    }
    let currentDate = new Date(this.selectedDate);
    currentDate = new Date(currentDate.getFullYear(), (currentDate.getMonth() + 1), 1);
    this.onMonthChange.emit(new Date(currentDate));
    this.selectedDate = new Date(currentDate);

    // update current date
    this.reloadHeaderData();
  }

  private reloadHeaderData() {
    if (this.schedularHeaderInfo) {
      this.schedularHeaderInfo.infos.forEach(element => {
        if (new Date(element.actualDate).toLocaleDateString() == new Date(this.selectedDate).toLocaleDateString()) {
          element.isCurrent = true;

        }
        else {
          element.isCurrent = false;
          element.classToSet = '';
        }
      });
    }

  }
  ViewDetails(content, day, data) {
    if (this.isUsedForUser) {
      let viewDetailsModel = {
        summaryModel: data,
        summaryDay: day
      }
      this.viewDetails.emit(viewDetailsModel);
    }
    else {
      const sday = new Date(day); 
      this.getMechanicInOutSummary(sday, data.mechanicId);
      this.selectedDay = `${weekDays[sday.getDay()]}, ${monthNames[sday.getMonth()]} ${sday.getDate()}`;
      const modelRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true });
      modelRef.result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    }
  }
  async getMechanicInOutSummary(sday, id) {
    this.spinner.show();
    const getMechanicInOutSummaryModel: MechanicInOutSummaryRequestModel = {
      selectedDay: sday,
      mechanicId: id
    }
    await this.appointmentPlanningService.getMechanicInOutSummary(getMechanicInOutSummaryModel)
      .then(result => {
        if (result) {
          this.summaryList = result;
          this.summaryList.forEach(element => {
            if (element.inTime != null)
              element.inTime = new Date(element.inTime + 'Z');
            if (element.outTime != null)
              element.outTime = new Date(element.outTime + 'Z');
          });
        }
        this.spinner.hide();
      });
  }

  totalHours(item) {
    let totalHours = 0;
    let totalMinutes = 0;
    item.forEach(d => {
      if (d !== '-') {
        const shiftHourssplit = d.split(':');
        totalHours = totalHours + (+shiftHourssplit[0]);
        totalMinutes = totalMinutes + (+shiftHourssplit[1]);
      }

    });
    if (parseInt((totalMinutes / 60).toString()) > 0) {
      totalHours = totalHours + parseInt((totalMinutes / 60).toString());
      totalMinutes = (totalMinutes % 60);
    }
    return (totalHours.toString().padStart(2, '0') + ':' + totalMinutes.toString().padStart(2, '0'));
  }

addTimeStrings(time1: string, time2: string): string {
  if (!time1 || !time2 || time1 === '-' || time2 === '-') {
    return '-';
  }

  const timeToMinutes = (timeStr: string): number => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const minutesToTime = (totalMinutes: number): string => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  const minutes1 = timeToMinutes(time1);
  const minutes2 = timeToMinutes(time2);
  const totalMinutes = minutes1 + minutes2;

  return minutesToTime(totalMinutes);
}
  totalOverTime(item) {
    let totalHours = 0;
    let totalMinutes = 0;
    item.overTime.forEach(daytime => {
      if (daytime !== '-') {
        const shiftHourssplit = daytime.split(':');
        totalHours = totalHours + (+shiftHourssplit[0]);
        totalMinutes = totalMinutes + (+shiftHourssplit[1]);
      }
    });

    if (parseInt((totalMinutes / 60).toString()) > 0) {
      totalHours = totalHours + parseInt((totalMinutes / 60).toString());
      totalMinutes = (totalMinutes % 60);
    }
    return (totalHours.toString().padStart(2, '0') + ':' + totalMinutes.toString().padStart(2, '0'));
  }

  totalActualInTime(item){
    let totalHours = 0;
    let totalMinutes = 0;
    item.actualInTime.forEach(daytimes => {
      if (daytimes !== '-') {
        const shiftHourssplit = daytimes.split(':');
        totalHours = totalHours + (+shiftHourssplit[0]);
        totalMinutes = totalMinutes + (+shiftHourssplit[1]);
      }
    });

    if (parseInt((totalMinutes / 60).toString()) > 0) {
      totalHours = totalHours + parseInt((totalMinutes / 60).toString());
      totalMinutes = (totalMinutes % 60);
    }
    return (totalHours.toString().padStart(2, '0') + ':' + totalMinutes.toString().padStart(2, '0'));
  }

  getTotalHoursWithLunch(item: any): string {
  let totalMinutes = 0;

  for (let i = 0; i < item.totalHours.length; i++) {
    const totalHour = item.totalHours[i];
    const lunchTime = item.lunchTime[i];
    
    if (totalHour && totalHour !== '-' && lunchTime && lunchTime !== '-') {
      const timeToMinutes = (timeStr: string): number => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      };

      totalMinutes += timeToMinutes(totalHour) + timeToMinutes(lunchTime);
    } else if (totalHour && totalHour !== '-') {
      const timeToMinutes = (timeStr: string): number => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      };
      totalMinutes += timeToMinutes(totalHour);
    }
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
    totalLunchTime(item) {
    let totalHours = 0;
    let totalMinutes = 0;
    item.lunchTime.forEach(daytime => {
      if (daytime !== '-') {
        const shiftHourssplit = daytime.split(':');
        totalHours = totalHours + (+shiftHourssplit[0]);
        totalMinutes = totalMinutes + (+shiftHourssplit[1]);
      }
    });

    if (parseInt((totalMinutes / 60).toString()) > 0) {
      totalHours = totalHours + parseInt((totalMinutes / 60).toString());
      totalMinutes = (totalMinutes % 60);
    }
    return (totalHours.toString().padStart(2, '0') + ':' + totalMinutes.toString().padStart(2, '0'));
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
